import type { GeneratedSet } from '../types/lotto';

function roundRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number,
) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

const PNG_W = 800;
const ROW_H = 70;
const PAD_TOP = 80;
const PAD_BOT = 60;

function renderSetsToCanvas(sets: GeneratedSet[], title: string, footerUrl: string): HTMLCanvasElement | null {
  if (!sets.length) return null;
  const canvas = document.createElement('canvas');
  const H = PAD_TOP + sets.length * ROW_H + PAD_BOT;
  canvas.width = PNG_W;
  canvas.height = H;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  const grad = ctx.createLinearGradient(0, 0, PNG_W, H);
  grad.addColorStop(0, '#667eea');
  grad.addColorStop(1, '#764ba2');
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, PNG_W, H);

  ctx.fillStyle = 'rgba(255,255,255,0.95)';
  roundRect(ctx, 20, 20, PNG_W - 40, H - 40, 16);
  ctx.fill();

  ctx.fillStyle = '#333';
  ctx.font = 'bold 28px -apple-system, sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText(`${title} Numbers`, PNG_W / 2, 58);

  const now = new Date();
  const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  ctx.fillStyle = '#888';
  ctx.font = '13px -apple-system, sans-serif';
  ctx.textAlign = 'right';
  ctx.fillText(dateStr, PNG_W - 40, 58);

  ctx.font = '20px -apple-system, sans-serif';
  ctx.textAlign = 'left';
  sets.forEach((set, i) => {
    const y = PAD_TOP + i * ROW_H + 35;
    ctx.fillStyle = '#888';
    ctx.fillText(`Set ${i + 1}:`, 50, y);
    ctx.fillStyle = '#333';
    ctx.font = 'bold 20px -apple-system, sans-serif';
    const nums = set.regular.join('  ');
    ctx.fillText(nums, 130, y);
    ctx.fillStyle = '#f5576c';
    ctx.fillText(`+  ${set.powerball}`, 130 + ctx.measureText(`${nums}  `).width, y);
    ctx.font = '20px -apple-system, sans-serif';
  });

  ctx.fillStyle = '#667eea';
  ctx.font = '14px -apple-system, sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText(footerUrl, PNG_W / 2, H - 32);

  return canvas;
}

export function downloadSetsAsPng(
  sets: GeneratedSet[],
  title: string,
  filename: string,
  footerUrl: string,
) {
  const canvas = renderSetsToCanvas(sets, title, footerUrl);
  if (!canvas) return;
  canvas.toBlob((blob) => {
    if (!blob) return;
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
  });
}
